import PropTypes from "prop-types";
import React, { Component } from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { dateToString } from "components/Shared/Formatters";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";

class DatePicker2Field extends Component {
  constructor(props) {
    super(props);
    this.clearDate = this.clearDate.bind(this);
  }

  clearDate(event) {
    event.preventDefault();
    let newDate = null;
    this.props.input.onChange(newDate);
  }

  render() {
    let hasValue = this.props.input.value;
    hasValue = hasValue.length > 0 && hasValue.indexOf("0001-01-01") == -1; // check for J bday
    const value = this.props.input.value ? new Date(this.props.input.value) : null;
    
    return (
      <div style={{ position: "relative" }}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            className={this.props.containerClassName}
            onChange={(newValue) => this.props.input.onChange(dateToString(newValue))}
            value={value}
            slotProps={{
              textField: {
                variant: "standard",
                fullWidth: false,
              }
            }}
          />
        </LocalizationProvider>
        {hasValue &&
          <IconButton
            onClick={this.clearDate}
            style={{ position: "absolute", top: "16px", left: "180px", padding: "0", width: "24px", height: "24px" }}
            size="small"
          >
            <Icon>delete_forever</Icon>
          </IconButton>}
      </div>
    );
  }
}

DatePicker2Field.propTypes = {
  input: PropTypes.object.isRequired,
  name: PropTypes.string,
  containerClassName: PropTypes.string
};
export default DatePicker2Field;